export enum EventBlockSystemDataFieldType {
    Style = "Style",
    Code = "Code"
}